import { FC } from 'react';

import classNames from 'classnames';

import { Button, Heading } from '../../shared/ui';

interface BackgroundModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBlur: () => void;
  backgrounds: { id: string; src: string }[];
  onSelect: (src: string) => void;
}

export const BackgroundModal: FC<BackgroundModalProps> = ({ isOpen, onClose, onBlur, backgrounds, onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-control p-6 w-full max-w-[480px] max-h-[80vh] overflow-y-auto">
        <Heading size="md" as="h3" className="text-center mb-6">
          Выберите фон
        </Heading>

        <Button size="md" variant="neutral" fullWidth className="mb-4" onClick={onBlur}>
          🌫️ Размытие фона
        </Button>

        <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mb-6">
          {backgrounds.map((bg) => (
            <div
              key={bg.id}
              className={classNames(
                'relative cursor-pointer rounded-chip overflow-hidden border border-line hover:border-primary transition-all',
              )}
              onClick={() => onSelect(bg.src)}
            >
              <img src={bg.src} alt={bg.id} className="w-full h-24 object-cover" />
            </div>
          ))}
        </div>

        <Button size="md" variant="neutral" fullWidth onClick={onClose}>
          Отмена
        </Button>
      </div>
    </div>
  );
};
